export type MunilyTitlePreviewSize = 'large' | 'medium' | 'small';

export const MUNILY_TITLE_PREVIEW_DEFAULTS = {
  value: '',
  showEditIcon: true,
  size: 'large' as MunilyTitlePreviewSize,
};
